import _t from 'i18n!nls/teach-course';

class SlugValidationState {
  declare id: number;

  declare message: string;

  constructor(id: number, message?: string) {
    this.id = id;
    this.message = message || _t('Lower-case letters, numbers, and dashes only.');
  }
}

class Unknown extends SlugValidationState {
  constructor() {
    super(0);
  }
}

class InProgress extends SlugValidationState {
  constructor() {
    super(1);
  }
}

class Unavailable extends SlugValidationState {
  constructor() {
    super(2, _t('Sorry, this URL is already in use.'));
  }
}

class BadFormat extends SlugValidationState {
  constructor() {
    super(3);
  }
}

class Valid extends SlugValidationState {
  constructor() {
    super(4);
  }
}

class SlugTooLong extends SlugValidationState {
  constructor({ maxLength }: { maxLength: number }) {
    super(5, _t('URL cannot be longer than #{numCharacters} characters.', { numCharacters: maxLength }));
  }
}

const exported = {
  SlugValidationState,
  Unknown,
  InProgress,
  Unavailable,
  BadFormat,
  Valid,
  SlugTooLong,
};

export default exported;
export { SlugValidationState, Unknown, InProgress, Unavailable, BadFormat, Valid, SlugTooLong };
